/* eslint-disable no-dupe-keys */
export default {
  evcs_charge_record: {
    name: '第三方设备充电记录',
    // 属性（一般与对象内容匹配）
    prop: {
      evcs_connector: '第三方设备接口',
      start_charge_seq: '订单号',
      qr_code: '二维码',
      start_charge_seq_stat: '初始订单状态',
      start_succ_stat: '启动操作结果',
      stop_succ_stat: '停止操作结果',
      evcs_operator: '第三方平台商',
      user: '用户'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      keyword: '关键词',
      evcs_connector_id: '第三方设备接口',
      start_charge_seq: '订单号',
      qr_code: '二维码',
      start_charge_seq_stat: '初始订单状态',
      start_succ_stat: '启动操作结果',
      start_fail_reason: '启动失败原因',
      stop_succ_stat: '停止操作结果',
      stop_fail_reason: '停止失败原因',
      evcs_operator_id: '第三方平台商',
      user_id: '用户',
      created_at: '创建时间',
      updated_at: '更新时间',
      evcs_operator: '第三方平台'
    },
    // Enum的属性
    start_charge_seq_stats: {
      starting: '启动中',
      charging: '充电中',
      stopping: '停止中',
      charged: '已结束',
      unknown: '未知'
    },
    start_succ_stats: {
      success: '成功',
      failure: '失败'
    },
    stop_succ_stats: {
      success: '成功',
      failure: '失败'
    },
    has_orders: {
      true: '有订单'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询订单号',
      search_evcs_operator: '选择第三方平台商'
    },
    // 详情页标签
    qrcode_dialog: {
      title: '二维码'
    }
  }
}
